import Box from '@mui/material/Box';
import {isMobile} from 'react-device-detect';
import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {constance} from '../common/constance/constance';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import {useSelector} from 'react-redux';
import {config} from '../common/config/config';
import {useNavigate} from 'react-router-dom';
import PostListTable from "./post/table/PostListTable";
import {PostInterface} from "../interface/post.interface";
import {MenuInterface} from "../interface/menu.interface";
import {Paper} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {RootState} from "../reducer";


interface State {
    postList: PostInterface[],
    menu: MenuInterface
}

export default function MainPage() {

    const [state, setState] = useState<State>({
        postList: [],
        menu: {
            allowAdminPost: false,
            allowAdminReply: false,
            id: "",
            index: 0,
            name: "",
            path: "",
            placeholder: "",
            subMenu: [],
            viewComment: false
        }
    })

    const navigate = useNavigate();
    const commonData = useSelector((state: RootState) => state.commonData);

    useEffect(() => {
        console.log('%c[MainPage]', 'color: yellow');
        if (commonData.user.id !== '') {
            axios.get(constance.api.getRecentPostList).then(value => {
                console.log(value)
                if (value.data.result) {
                    setState({
                        ...state,
                        postList: value.data.result
                    })
                } else {
                    navigate('/login');
                }
            }).catch(reason => {
                console.log(reason);
            })
        }
    }, [commonData.user.id]);

    function handleMoveAllPostList() {
        navigate(`${config.url.board}?id=all&page=1&keyword=&search-type=title`);
    }

    return (
        <Box sx={{display: 'flex', justifyContent: 'center', p: {xs: 1, md: 2}}}>
            <Stack sx={{
                width: 1,
                maxWidth: config.maxWidth,
                gap: {xs: 3, md: 4},
            }}>
                {/* 히어로 배너 */}
                <Paper
                    elevation={0}
                    sx={{
                        display: {xs: 'none', sm: 'none', md: 'block'},
                        position: 'relative',
                        height: 280,
                        overflow: 'hidden',
                        borderRadius: 2,
                        border: 1,
                        borderColor: 'divider',
                    }}
                >
                    <img
                        src="/images/main-background.png"
                        alt="메인 배경"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            objectPosition: 'center 72%',
                            display: 'block',
                        }}
                    />
                    <Box
                        sx={{
                            position: 'absolute',
                            inset: 0,
                            background:
                                'linear-gradient(180deg, rgba(0,0,0,0.0) 30%, rgba(0,0,0,0.35) 100%)',
                            pointerEvents: 'none',
                        }}
                    />
                </Paper>

                {/* 최근 게시글 섹션 */}
                <Box>
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        sx={{mb: 1.5, px: 0.5}}
                    >
                        <Typography variant={isMobile ? 'subtitle1' : 'h6'}
                                    sx={{fontWeight: 600}}>
                            최근 게시글
                        </Typography>
                        <Button
                            onClick={handleMoveAllPostList}
                            size="small"
                            variant="text"
                            endIcon={<ArrowForwardIcon sx={{fontSize: 16}}/>}
                            sx={{color: 'text.secondary', textTransform: 'none'}}
                        >
                            <Typography variant="body2">전체 보기</Typography>
                        </Button>
                    </Stack>

                    <PostListTable postList={state.postList} menu={state.menu}/>
                </Box>
            </Stack>
        </Box>
    );
}
